module.exports = __webpack_public_path__ + "c45fd52b5114f81d27e2c831300d5e64.jpg";